import OcrMotion from './ocr/OcrMotionB';

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden border-b border-rule">
      <div className="mx-auto max-w-[1280px] px-6 pt-20 md:px-10 md:pt-28">
        <p className="label-mono mb-8 text-accent">— ai · nexenio · 01 / OCR</p>

        <div className="grid gap-10 md:grid-cols-12 md:gap-16">
          <h1
            aria-label="Sichere OCR. Made in Germany."
            className="text-[44px] font-extrabold uppercase leading-[0.95] tracking-[-0.02em] text-fg md:col-span-7 md:text-[64px] lg:text-[88px]"
          >
            <span aria-hidden="true">
              Sichere OCR<span className="text-accent">.</span>
              <br />
              <span className="text-fg-muted">Made in</span>
              <br />
              Germany<span className="text-accent">.</span>
            </span>
          </h1>

          <div className="md:col-span-5 md:pt-4">
            <p className="max-w-xl text-base leading-relaxed text-fg-muted md:text-lg">
              Produktionsreife OCR und Dokumentenverstehen auf GPUs in Deutschland.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href="#contact"
                className="border border-accent bg-accent px-5 py-3 font-mono text-[12px] font-semibold uppercase tracking-[0.12em] text-bg hover:bg-accent-deep"
              >
                Gespräch anfragen
              </a>
              <a
                href="#ocr"
                className="border border-rule px-5 py-3 font-mono text-[12px] font-semibold uppercase tracking-[0.12em] text-fg hover:border-fg-muted"
              >
                Live ansehen
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto mt-16 max-w-[1280px] px-6 pb-20 md:px-10 md:pb-28">
        <div className="border border-rule bg-bg-elev">
          <div className="flex items-baseline justify-between border-b border-rule px-5 py-3 font-mono text-[11px] uppercase tracking-[0.12em] text-fg-muted">
            <span>
              <span className="font-semibold text-accent">demo</span> · ocr.live
            </span>
            <span className="hidden sm:inline">Beispiel: Arztbrief</span>
            <span>Pixel → Glyphen → Text</span>
          </div>
          <OcrMotion />
        </div>
      </div>
    </section>
  );
}
